import type { InteriorView } from "@slfinrtl/ui-bff-routes"
import { FormProvider } from "react-hook-form"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { CustomInteriorColor } from "./components/CustomInteriorColor"
import { CustomInteriorColorSkeleton } from "./components/CustomInteriorColorSkeleton"
import { useCustomInterior } from "./useCustomInterior"

export interface CustomInteriorContainerProps {
	currentInterior: InteriorView | undefined
	inventoryId: string
	onInteriorCreated: (interior: InteriorView) => void
	showCatalogInteriorContainer: () => void
}

export const CustomInteriorContainer = withErrorHandler(
	({
		currentInterior,
		inventoryId,
		onInteriorCreated,
		showCatalogInteriorContainer,
	}: CustomInteriorContainerProps) => {
		const { form, onSubmit, props } = useCustomInterior({
			currentInterior,
			inventoryId,
			onInteriorCreated,
			showCatalogInteriorContainer,
		})
		return (
			<>
				<ErrorNotificationInline />
				{props ? (
					<FormProvider {...form}>
						<form onSubmit={form.handleSubmit(onSubmit)} noValidate>
							<CustomInteriorColor {...props} />
						</form>
					</FormProvider>
				) : (
					<CustomInteriorColorSkeleton />
				)}
			</>
		)
	},
)
